var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPTicket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.49744 2H3.49744C1.58244 2 1.04744 2.46 1.00244 4.25C1.96744 4.25 2.74744 5.035 2.74744 6C2.74744 6.965 1.96744 7.745 1.00244 7.75C1.04744 9.54 1.58244 10 3.49744 10H8.49744C10.4974 10 10.9974 9.5 10.9974 7.5V4.5C10.9974 2.5 10.4974 2 8.49744 2Z",
    stroke: "#798293",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.49658 2V3.75",
    stroke: "#798293",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.49658 8.25V10",
    stroke: "#798293",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.51251 4.66508L7.82251 5.29008C7.85251 5.35008 7.91251 5.39508 7.97751 5.40508L8.66751 5.50508C8.83751 5.53008 8.90751 5.74008 8.78251 5.86008L8.28251 6.34508C8.23251 6.39008 8.21251 6.46008 8.22251 6.53008L8.34251 7.21508C8.37251 7.38508 8.19251 7.51508 8.04251 7.43508L7.42751 7.11008C7.36751 7.08008 7.29251 7.08008 7.23251 7.11008L6.61751 7.43508C6.46251 7.51508 6.28751 7.38508 6.31751 7.21508L6.43751 6.53008C6.44751 6.46008 6.42751 6.39508 6.37751 6.34508L5.88251 5.86008C5.75751 5.74008 5.82751 5.53008 5.99751 5.50508L6.68751 5.40508C6.75751 5.39508 6.81251 5.35508 6.84251 5.29008L7.14751 4.66508C7.21751 4.51008 7.43751 4.51008 7.51251 4.66508Z",
    stroke: "#798293",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPTicket);
export default __webpack_public_path__ + "static/media/p_ticket.615ad8d52d82dd0d17f48a4f81fac89f.svg";
export { ForwardRef as ReactComponent };